var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { h } from "vue";
import { SmartRenderer, resolveVNode } from "../../../lib/utils.js";
import get from "../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js";
function createColumns(args) {
  const { columnHelper, columns = [], slots, sortingValueRef } = args, vueTableColumns = [], sortingValue = [];
  for (const column of columns) {
    const accessor = Array.isArray(column.dataIndex) ? column.dataIndex.join(",") : column.dataIndex ?? column.key, c = columnHelper.accessor(accessor, {
      header: /* @__PURE__ */ __name(() => h(SmartRenderer, { children: resolveVNode(column.title) }), "header"),
      cell: /* @__PURE__ */ __name((props) => {
        var _a;
        const value = column.dataIndex ? get(props.row.original, column.dataIndex) : void 0;
        return column.renderSlot && slots ? (_a = slots[column.renderSlot]) == null ? void 0 : _a.call(slots, {
          value,
          record: props.row.original,
          index: props.row.index
        }) : column.render ? column.render(value.value, props.row.original, props.row.index) : value;
      }, "cell"),
      meta: { ...column }
    });
    (column.sortOrder === "asc" || column.sortOrder === "desc") && sortingValue.push({ id: accessor, desc: column.sortOrder === "desc" }), vueTableColumns.push(c);
  }
  return sortingValueRef.value = sortingValue, vueTableColumns;
}
__name(createColumns, "createColumns");
function isUpdaterFunc(updater) {
  return typeof updater == "function";
}
__name(isUpdaterFunc, "isUpdaterFunc");
function updaterHelper(updater, r) {
  r.value = isUpdaterFunc(updater) ? updater(r.value) : updater;
}
__name(updaterHelper, "updaterHelper");
function object2array(obj) {
  const arr = [];
  if (!obj)
    return arr;
  for (const key in obj)
    obj[key] && arr.push(key);
  return arr;
}
__name(object2array, "object2array");
function array2object(arr) {
  const obj = {};
  return arr && arr.forEach((v) => obj[v] = !0), obj;
}
__name(array2object, "array2object");
export {
  array2object,
  createColumns,
  object2array,
  updaterHelper
};
//# sourceMappingURL=utils.js.map
